module.exports = __webpack_public_path__ + "img/image06_sp.b1455814.jpg";